<template>
  <div
    v-show="open"
    class="right-click-menu"
    :style="style"
    @mouseover.stop="highlightMyTarget(target)"
  >
    <div
      v-for="(action, idx) in actions"
      :key="action.label + idx"
      class="right-click-menu__option"
      @click.prevent.stop="execute(action)"
    >
      {{ action.label }}
      <i
        class="material-icons"
        v-text="action.icon"
      />
    </div>
  </div>
</template>

<script>
  import * as getters from '../../store/modules/getters'
  import * as mutations from '../../store/modules/mutations'
  import * as actions from '../../store/modules/actions'
  import { mapGetters, mapMutations, mapActions } from 'vuex'

  export default {
    data () {
      return {
        actions: [
          { label: 'Settings', icon: 'settings', 'method': 'select' },
          { label: this.$t('layout.manage.duplicate'), icon: 'content_copy', 'method': 'duplicateAndValidate' },
          { label: this.$t('layout.manage.delete'), icon: 'delete_forever', 'method': 'removeAndValidate' },
        ]
      }
    },
    computed: {
      ...mapGetters({
        open: getters.RIGHT_CLICK_MENU_OPEN,
        selected: getters.SELECTOR_SELECTED,
        position: getters.RIGHT_CLICK_MENU_POSITION,
        target: getters.RIGHT_CLICK_MENU_TARGET,
        config: getters.AUTH_GET_USER_CONFIG
      }),
      style () {
        return {
          position: 'fixed',
          ...this.position
        }
      }
    },
    watch: {
      selected () {
        this.reset()
      }
    },

    destroyed () {
      window.removeEventListener('click', this.hideWhenClickedOutside, {passive: true})
    },

    mounted () {
      window.addEventListener('click', this.hideWhenClickedOutside, {passive: true})
    },

    methods: {
      ...mapMutations({
        toggle: mutations.RIGHT_CLICK_MENU_TOGGLE
      }),
      ...mapActions({
        reset: actions.RIGHT_CLICK_MENU_RESET,
        highlightMyTarget: actions.SELECTOR_TARGET
      }),
      execute (action) {
        this.target[action.method]()
        this.reset()
      },

      hideWhenClickedOutside (e) {
        if (this.open && e.target !== this.$el) {
          this.reset()
        }
      }
    }
  }
</script>

<style lang="scss">
  @import "@/scss/utils";

  .right-click-menu {
    width: 200px;
    max-height: 200px;
    z-index: 5;
    background: $inf-dark-blue;
    margin: auto;
    display: flex;
    flex-direction: column;
  }

  .right-click-menu__option {
    cursor: pointer;
    color: $white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 35px;
    font-size: 15px;
    padding: 20px;

    .material-icons {
      font-size: 20px;
    }

    &:hover {
      color: $green;
    }
  }
</style>
